<template>
 
  <vs-row>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="12"
      >
       <vs-card class="cstm-card w-full mb-4 collapse-cstm-card">
          <div class="collapse-item">
         <div class="flex justify-between header" slot="header" @click="isCollapseCard=!isCollapseCard" :class="{activeCollapse: isCollapseCard}">
            <h5>{{label}}</h5>
            <span class="material-icons">keyboard_arrow_down</span>
          </div>
          <div class="collapseContent" v-show="isCollapseCard" :class="{active: isCollapseCard}">
          <vs-row>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center">
    <editor
    v-model="localContentValue"
       :api-key="tinyMceApi"
       :init="{
         height: 500,
         menubar: true,
         branding: false,
         images_upload_url: image_url,
         automatic_uploads: true,
         images_upload_credentials:true,
         images_upload_handler:example_image_upload_handler,
         plugins: [
          'autolink lists link image charmap print preview anchor',
          'imagetools',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount',
          'code lists fullscreen',
          'emoticons'
        ],
         menu:'table',
         toolbar:'insertfile image link |undo redo | formatselect | bold italic backcolor | \
        table alignleft aligncenter alignright alignjustify | \
        bullist numlist outdent indent | removeformat | help',
        
           
       }"
     />
              </vs-col>
          </vs-row>
          </div>
          </div>
      </vs-card>
      </vs-col>
  </vs-row>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import { contentFileUpload} from '@/api/course-builderapi'


export default {
  data () {
    return {
      isCollapseCard: true,
      // contenturl:this.image_url,
      image_url:'',
      tinyMceApi:''
    }
  },
  beforeMount () {
    console.log(`base url: ${  process.env.VUE_APP_TINYMCE_API}`)
  },

  created () {
    // const customr
    this.tinyMceApi = process.env.VUE_APP_TINYMCE_API

    const customer_id = this.$store.getters.customerId
    const imageUploadUrl = process.env.VUE_APP_IMAGE_UPLOAD_URL
    this.image_url = `${imageUploadUrl}${customer_id}`

    console.log(this.image_url)

    // this.image_url = ' https://www.mocky.io/v2/5d4fb20b3000005c111099e3'
  },
  props:{
    label:{

    },
    value:{

      default:''

    }
  },
  components: {
    'editor': Editor
  },
  computed:{
    localContentValue:{
      get () {
        return this.value

      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods:{
   

    images_upload_handler (blobInfo, success, failure) {
      console.log('hi')
      console.log(blobInfo)

      const xhr = new XMLHttpRequest()
      xhr.withCredentials = true
      xhr.open('POST', this.image_url)

      xhr.upload.onprogress = function (e) {
        progress(e.loaded / e.total * 100)
      }

      xhr.onload = function () {
        // let json

        if (xhr.status === 403) {
          failure(`HTTP Error: ${  xhr.status}`, { remove: true })
          return
        }

        if (xhr.status < 200 || xhr.status >= 300) {
          failure(`HTTP Error: ${  xhr.status}`)
          return
        }

        const json = JSON.parse(xhr.responseText)

        if (!json || typeof json.location !== 'string') {
          failure(`Invalid JSON: ${  xhr.responseText}`)
          return
        }

        success(json.location)
      }

      xhr.onerror = function () {
        failure(`Image upload failed due to a XHR Transport error. Code: ${  xhr.status}`)
      }

      // config.headers['Authorization'] = `Bearer ${JSON.parse(localStorage.getItem('access_token'))}`

      xhr.setRequestHeader('Authorization', `Bearer ${JSON.parse(localStorage.getItem('access_token'))}`)


      const formData = new FormData()
      formData.append('files[0]', blobInfo.blob(), blobInfo.filename())

      console.log(formData)

      xhr.send(formData)
    },
    example_image_upload_handler (blobInfo, success, failure, progress) {

      const formData = new FormData()
      formData.append('files[0]', blobInfo.blob())

      const data =  this.fileupload(formData)

      data.then(res => {
        console.log(res)
        // const stringresponse = res.replace(/,/g, '')
        // console.log(str.);
        // success(JSON.stringify(res))

        console.log(res)
        
        const locationObject = {
          src:{
            value:{
              location:res
            }
          }
        }

        const stringify = JSON.stringify(res)
        const parse = JSON.parse(stringify)
        console.log(locationObject)
        // success(JSON.stringify(res))

        success(parse)
      }).catch(error => {
        console.log(error)
      })
     

      // console.log(blobInfo.filename)

      // // console.log(formData)

      // xhr.send(formData)
    },
    async fileupload (payload) {
      try {
        const customer_id = this.$store.getters.customerId

        console.log(payload)

        const responseImage = await contentFileUpload(customer_id, payload)

        // console.log(responseImage)
        const location = responseImage.data.data.cdn + responseImage.data.data.files[0].file_path
        this.$vs.notify({
          title:'Success',
          text: 'IMage Uploaded Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color:'success',
          time: 3000
        })
        return (location)
      } catch (error) {
        console.log(error)
      }
    } 
  
  
  }
  
}
</script>